import React from "react";
import { Container, Row, Col } from "reactstrap";

const PageTwo = () => {
  return (
    <Container fluid={true} className="main-body-container">
      <Row>
        <Col xs="1" md="6"></Col>
        <Col xs="10" md="5">
          <h2>Now, thanks to virtual reality, we’ve done what isn’t possible in the real world.</h2>
        </Col>
        <Col xs="1" md="1"></Col>
      </Row>
      <Row className="offset-row">
        <Col xs="1" md="3"></Col>
        <Col xs="10" md="5">
          <h2>
            Facebook and Oculus, guided by St. Jude, have transformed twelve brave patients into epic statues fifty feet
            tall.
          </h2>
        </Col>
        <Col xs="1" md="4"></Col>
      </Row>
    </Container>
  );
};

export default PageTwo;
